import styled from 'styled-components'

export const Wrapper = styled.div`
display: flex;
justify-content: center;
align-items: center;
height: 100%;
width: 100%;

`
export const CardContent = styled.div`
display: flex;
justify-content: center;
align-items: center;
flex-direction: column;
height:${(props) => (props.isMobile ? '90%' : '80%')};
width:${(props) => (props.isMobile ? '95%' : '670px')};
font-feature-settings: 'clig' off, 'liga' off;
font-family: var(--general-font-family);
color: var(--font-color-blue002e5c);
background-color: #fff;
border-radius: 10px;
div{
display: flex;
justify-content: center;
align-items: center;
flex-direction: column;

}

p{
text-align: center;
font-size: var(--general-large-body-font-size);
font-weight: var(--general-large-body-font-weight);
line-height: 26.348px; 
width: 83%;
}
`
export const Title = styled.h1`
font-size: ${(props) => (props.isMobile ? 'var(--general-page-header-font-size)' : 'var(--payment-result-page-header-font-size)')};
font-weight: var(--font-weight-semi-bold);
padding-bottom: 22px;
padding-top: ${(props) => (props.isMobile ? '20px' : '45px')};
`

export const ThanksMsg = styled.div`
font-size: var(--general-header-font-size);
font-weight: var(--general-header-font-weight);
line-height: 26.348px; 
width: 83%;
text-align: center;
margin-top: 20px;
`


export const ButtonWrapper = styled.div`
color: var(--font-color-white);
display: flex;
justify-content: center;
align-items: center;

font-size: var(--general-button-font-size);
font-weight: var(--general-button-font-weight);
margin-top: 120px;
button{
    border: 0;
    width: 185px;
    height: 48px;
}
button:nth-child(1){
    display: flex;
    width: 185px;
    padding: 8px 20px;
    justify-content: center;
    align-items: center;
    gap: 8px;
    border-radius: 5px;
    background: rgba(37, 85, 239, 1);
    color: var(--font-color-white);
    margin-bottom: 10px;
 
}
button:nth-child(2){
    color: var(--font-color-blue007bff);
    line-height: 32px;
    background-color: transparent;
   
}
`